import React, { useState, useEffect } from 'react';
import './PointRedeem.css';
import { useNavigate } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';

import getProfileImage from '../utils/getProfileImage';

function PointRedeem() {
  const navigate = useNavigate();
  const storedData = localStorage.getItem('userData');
  const [coupons, setCoupons] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
const [mode, setMode] = useState('QR'); // or 'BARCODE'
const [userData, setUserData] = useState(null);
const [isLoading, setIsLoading] = useState(false);
const [userTags, setUserTags] = useState([]);
  const [redeemedCouponIds, setRedeemedCouponIds] = useState([]);
const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);
const [showSpecialCoupon, setShowSpecialCoupon] = useState(false);
const [showSpecialCoupon2, setShowSpecialCoupon2] = useState(false);


const profileImage = getProfileImage()

useEffect(() => {
  localStorage.setItem('language', language);
  setT(language === 'EN' ? en : th);
}, [language]);

useEffect(() => {
  const fetchCoupons = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/coupon/?is_active=true&page=1&limit=1000`);
      const result = await res.json();
      if (result.content && result.content.data) {
        const filtered = result.content.data.filter(
          (c) => !(Number(c.id) === 389 && !showSpecialCoupon) && !(Number(c.id) === 391 && !showSpecialCoupon2)
        );
        setCoupons(filtered);
      }
    } catch (error) {
      console.error("Failed to fetch coupons:", error);
    }
    setIsLoading(false);
  };

  fetchCoupons();
}, [showSpecialCoupon, showSpecialCoupon2]);




useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
        // Check registration date and show special coupon 389 if eligible
        const regDateStr = result?.content?.data?.registered_date;
        const regDate = regDateStr ? new Date(regDateStr) : null;
        const threshold = new Date(2026, 1, 1); // 16/01/2026
        if (regDate && !isNaN(regDate.getTime()) && regDate >= threshold) {
          setShowSpecialCoupon(true);
        }
        const threshold2 = new Date(2026, 1, 30);
        if (regDate && !isNaN(regDate.getTime()) && regDate > threshold2) {
          setShowSpecialCoupon2(true);
        }
        fetch(
          `${CONFIG.API_BASE_URL}/tags/by-line/${localStorage.getItem('line_user_id')}`,
         )
          .then((r) => r.json())
           .then((tagRes) => {
             setUserTags(tagRes.tags || []);
           })
          .catch((e) =>
             console.error("Failed to fetch user tags:", e)
         );

        // fetch user's redeemed/owned coupons and hide them from list
        try {
          setIsLoading(true);
          const ures = await fetch(`${CONFIG.API_BASE_URL}/coupon/user_coupon?line_user_id=` + localStorage.getItem('line_user_id') + '&page=1&limit=1000');
          const ujson = await ures.json();
          const udata = ujson?.content?.data || ujson?.data || [];
          const ids = udata.map((uc) => Number(uc.coupon_id || uc.couponId || uc.coupon_id));
          setRedeemedCouponIds(ids.filter(Boolean));
        } catch (e) {
          console.error('Failed to fetch user coupons:', e);
        } finally {
          setIsLoading(false);
        }
      } else {
        throw new Error("Invalid user data format");
      }
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/');
    }
  };

  fetchUserData();
}, [navigate]);

console.log("User Data:", userTags);

  return (
    <div style={{ backgroundColor: ' #FFFFFF'}}>


            {isLoading && (
  <div className="full-screen-spinner">
    <div className="spinner" />
  </div>
)}
      <div className="point-header-gradient">
  <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
  <div className="right-section">
  <div className="lang-selector">
  <button
    className={`lang-button ${language === 'TH' ? 'active' : ''}`}
    onClick={() => setLanguage('TH')}
  >
    TH
  </button>
  |
  <button
    className={`lang-button ${language === 'EN' ? 'active' : ''}`}
    onClick={() => setLanguage('EN')}
  >
    EN
  </button>
</div>


    {/* <img src="/assets/avartar.png" alt="avatar" className="profile-avatar" /> */}
            {showMenu ? 
          <div >
           
 {showMenu && (
  <>
   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}

  </div>
    </div>

    <div className="point-header-bar">
    <button className="back-button" onClick={() => navigate(-1)}>
  <img src="/assets/arrow_back.png" alt="Back" className="back-icon" />
</button>
  <span className="point-header-title">{t.pointredeem.pointredeem}</span>
</div>


{/* Points summary and coupon button */}
<div className="points-summary-section">
  <div className="points-balance">
    <span className="points-amount">{userData?.point?.toLocaleString() || 0}</span>
    <img src="/assets/coin.png" alt="coin" className="coin-icon" />
  </div>

  <p className="points-expiry-text">{userData?.point?.toLocaleString() || 0} {t.pointredeem.point}</p>
  <button className="my-coupon-button" onClick={() => navigate('/my-coupon')}>
    <img src="/assets/confirmation_number.png" alt="icon" />
    {t.pointredeem.my_coupon}
  </button>
</div>

<hr className="dashed-line-gray" />
<br/>
{/* Coupon list */}
<div className="coupon-list">
  {coupons
    .filter(coupon => {
      // show if no tags
      if (!Array.isArray(coupon.tags) || coupon.tags.length === 0) {
        return true;
      }
      // otherwise only show if there's at least one matching tag
      return coupon.tags.some(tagId =>
        userTags.includes(String(tagId))
      );
    })
    .filter(coupon => {
      // hide if user already redeemed/owns this coupon
      if (redeemedCouponIds && redeemedCouponIds.length > 0) {
        return !redeemedCouponIds.includes(Number(coupon.id));
      }
      return true;
    })
    .map((coupon, index) => (
      <div key={index} className="coupon-card-potin-redeem">
        <img
          src={coupon.image_url}
          alt={language === 'EN' ? coupon.name_en : coupon.name}
          className="coupon-image-potinredeem"
        />

        <div className="coupon-details-potinredeem">
          <p className="coupon-title-potinredeem">
            {language === 'EN' ? coupon.name_en : coupon.name}
          </p>
          <p className="coupon-subtitle-potinredeem">
            {language === 'EN'
              ? coupon.short_description_en
              : coupon.short_description}
          </p>
          <p className="coupon-points-potinredeem">
            {coupon.point_cost?.toLocaleString() || 0}
            <img
              src="/assets/coin.png"
              alt="coin"
              className="coin-icon-card"
            />
          </p>
          {
            (() => {
              // determine signup-window eligibility
              let isEligibleBySignup = true;
              try {
                if (coupon.signup_start || coupon.signup_end) {
                  const regStr = userData?.registered_date;
                  const regDate = regStr ? new Date(regStr) : null;
                  if (!regDate || isNaN(regDate.getTime())) {
                    isEligibleBySignup = false;
                  } else {
                    if (coupon.signup_start) {
                      const start = new Date(coupon.signup_start);
                      if (regDate < start) isEligibleBySignup = false;
                    }
                    if (coupon.signup_end) {
                      const end = new Date(coupon.signup_end);
                      if (regDate > end) isEligibleBySignup = false;
                    }
                  }
                }
              } catch (e) {
                console.error('Signup-window check error', e);
                isEligibleBySignup = true; // fail-open UX wise
              }

              const btnClass = `redeem-button-potinredeem ${!isEligibleBySignup ? 'opacity-50 cursor-not-allowed' : ''}`;

              return (
                <button
                  className={btnClass}
                  onClick={() => {
                    if (!isEligibleBySignup) {
                      alert(t.pointredeem.redeem_not_eligible || 'You are not eligible to redeem this coupon');
                      return;
                    }
                    navigate(`/coupon-description?coupon_id=${coupon.id}`);
                  }}
                >
                  {t.pointredeem.redeem_coupon}
                </button>
              );
            })()
          }
        </div>
      </div>
    ))}
</div>






    </div>
  );
}

export default PointRedeem;